module.exports = __webpack_public_path__ + "img/logo.d6925b1b.png";